import React from "react";
import Header from "../home/header";
import { useLocation, useNavigate } from 'react-router-dom';
import { useEffect, useState } from "react";
import TransactionItem from "./transaction_item";
import { ApiClient } from "../../utils/api-client";
import Loading from "../home/Loading";
import PaginationControl from "../home/pagination_control";
import { AxiosError } from "axios";
import UTILS from "../../utils/commons";


const Transactions = ( props ) => {
    let navigate = useNavigate();
    let location = useLocation();
    var loginState = JSON.parse( window.sessionStorage.getItem( "loginState" ) );
    const apiClient = new ApiClient( loginState ? loginState.accessToken : null );
    const [ transactions, setTransactions ] = useState( [] );
    const [ filteredTransactions, setFilteredTransactions ] = useState( [] );
    const [ loading, setLoading ] = useState( false );
    const [ currentPage, setCurrentPage ] = useState( 1 );
    const [ pageSize, setPageSize ] = useState( 10 );
    const [ totalPages, setTotalPages ] = useState( 1 );
    const [ hasNextPage, setHasNextPage ] = useState( false );
    const [ hasPreviousPage, setHasPreviousPage ] = useState( false );
    const [ filterBy, setFilterBy ] = useState( "all" );
    const [managers, setManagers] = useState( [] );
    const canCreateTransaction = loginState?.role === UTILS.SALES;

    const handlePageChange = ( newPage ) => {
        setCurrentPage( newPage );
        loadTransactions( newPage, pageSize );
    }
    const handlePageSizeChange = ( newPageSize ) => {
        setPageSize( newPageSize );
        setCurrentPage( 1 );
        loadTransactions( 1, newPageSize );
    }
    const loadTransactions = async ( page, pageSize, filter = filterBy ) => {
        setLoading( true );
        try {
            const response = await apiClient.get( "/transactions/paginated", {
                params: {
                    page: page,
                    limit: pageSize,
                    profileId: ( loginState && loginState.role === UTILS.SALES ? loginState.profile.id :
                        ( filter !== 'all' && ( loginState.role === UTILS.ADMIN || loginState.role === UTILS.FINANCE ) ) ? filter : null ),
                    
                }
            } );
            setTransactions( response.data.data );
            setFilteredTransactions( response.data.data );
            setCurrentPage( response.data.page );
            setTotalPages( Math.ceil( response.data.totalPages / pageSize ) );
            setHasNextPage( response.data.hasNextPage );
            setHasPreviousPage( response.data.hasPreviousPage );
            setLoading( false );
        }
        catch ( e ) {
            console.log( "Error fetching transactions", e );
            setLoading( false );
            if ( e instanceof AxiosError && e.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, target: '/transactions' } );
            }
        }
    }

    const handleFilter = (e) => {
        let value = e.target.value;
        setFilterBy( value );
        loadTransactions( 1, pageSize, value );
    }
    const getManagers = async () => {
        try {
            const response = await apiClient.get( "/managers/list" );
            setManagers( response.data );
        }
        catch ( e ) {
            console.log( "Error fetching managers", e );
            if ( e instanceof AxiosError && e.status === 401 ) {
                UTILS.signout();
                navigate( '/signin', { replace: true, target: '/transactions' } );
            }
        }
    }

    useEffect( () => {
        loadTransactions( 1, pageSize );
        getManagers();
    }, [ pageSize ] );
    const confirmDelete = ( itemId ) => {
        let message = "Are you sure you want to delete this transaction?";
        if ( window.confirm( message ) ) {

            // deleteTransaction( itemId )
        }

    }
    const deleteTransaction = ( pid ) => {
        //
    }

    return ( <>
        <Header auth={loginState} />
        <section className="flex justify-start items-start">
            <div className="container">
                <div className="rounded-xl border border-gray-200 bg-gradient-to-r from-white to-gray-50 p-4 md:p-5">
                    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
                        <div>
                            <p className="text-sm uppercase tracking-wide text-gray-500">Sales</p>
                            <p className="text-2xl font-semibold text-gray-800">Transactions</p>
                        </div>
                        <div className="w-full md:w-auto flex flex-col md:flex-row gap-3">
                            <input className="w-full md:w-80 px-3 py-2 focus:outline-none rounded-md border border-gray-300 focus:ring-2 focus:ring-gray-300" type="text" placeholder="Search transactions..." onChange={( e ) => {
                                let keyword = e.target.value.toLowerCase();
                                let filteredResults = transactions.filter( p =>
                                    ( p?.customer?.name || '' ).toLowerCase().includes( keyword ) ||
                                    ( p?.manager?.firstName || '' ).toLowerCase().includes( keyword ) ||
                                    ( p?.manager?.lastName || '' ).toLowerCase().includes( keyword ) ||
                                    String( p?.totalAmount || '' ).toLowerCase().includes( keyword )
                                );
                                setFilteredTransactions( filteredResults );
                            }} />
                            {canCreateTransaction ? <button className="btn bg-success md:min-w-[7rem]" onClick={() => navigate( "/transactions/new", { replace: false } )}>Add Sale</button> : null}
                        </div>
                    </div>
                </div>
                {loading ? ( <Loading className="mx-auto mt-16" /> ) : (
                    <div className="mt-12">
                        <div className="md:flex justify-between items-center mb-4">
                            {loginState?.role !== UTILS.SALES ? <select value={filterBy} onChange={handleFilter} className="px-3 py-1 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-gray-300">
                                <option value="all">All Managers</option>
                                {managers.map( m => <option key={m.id} value={m.id}>{m.firstName} {m.lastName}</option> )}
                            </select> : <span></span>}
                            <PaginationControl pageSize={pageSize} currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} onPageSizeChange={handlePageSizeChange} hasNextPage={hasNextPage} hasPreviousPage={hasPreviousPage} />
                        </div>
                        <div className="border border-gray-200 rounded-lg overflow-hidden pt-0 grid md:grid-cols-1 gap-0 md:justify-start md:items-center flex-wrap" id="list_container">
                            <div className="grid md:grid-cols-7 bg-gray-100 p-3 font-semibold text-gray-700 ">
                                <span>Date</span>
                                <span>Manager</span>
                                <span>Type</span>
                                <span>Customer</span>
                                <span>Amount (TSH)</span>
                                <span className="text-start">Document</span>
                                <span>Actions</span>
                            </div>
                            {filteredTransactions && filteredTransactions.length > 0 ? filteredTransactions.map( ( r, idx ) => {
                                return <TransactionItem className={idx % 2 === 0 ? "bg-white" : "bg-gray-100"} data={r} key={r.id} onDelete={() => confirmDelete( r.id )} onClick={() => { navigate( "/transactions/view/" + r.id, { replace: false, state: r } ) }} onEdit={() => { navigate( "/transactions/edit/" + r.id, { replace: false, state: r } ) }} />
                            } ) : <span className="text-center w-full py-8 text-gray-500">No data</span>
                            }
                        </div>
                    </div>
                )}</div>
        </section>
    </> )

}
export default Transactions;
